import React, { useState, useEffect } from "react";
import Config from "../../env/config";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { createServiceRequestOfFeedback, sendLeadNotificationEmail } from "../../API/services";
import Modal from '../../Components/Modal/Modal';
import CustomInput from "../../Components/CustomInput/CustomInput";
import AutoComplete from "../../Components/AutoComplete/AutoComplete";
import Textarea from "../../Components/Textarea/Textarea";
import CustomCheckbox from "../../Components/CheckBox/CheckBox";
import Button from "../../Components/Button/Button";
import ButtonLoader from "../../Components/ButtonLoader/ButtonLoader";
import Error from "../../Components/Error/Error";
import { useLang } from "../../Utility/hooks/useLang";
import "./HomePageBanner.scss";

const HomePageBanner = () => {
  const CDN_URL = Config.CDN_URL;
  const navigate = useNavigate();
  const { lang } = useLang();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  // this function is used to set language as en. To disable the language conversion in sales journey
  const setLangInSession = () => {
    // sessionStorage.setItem("lang", "en");
  }
  const [isGetQuotesHomeInsuranceModalOpen, setGetHomeInsuranceQuotesModalOpen] = useState(false);
  const closeGetQuotesModal = () => {
    setGetHomeInsuranceQuotesModalOpen(false);
  };
  // const [clickHereModal, setClickHereModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const handleCheckboxChange = () => {
    setIsSubscribed((prev) => !prev);
  };
  const [callBackData, setCallBackData] = useState({
    name: "",
    email: "",
    countryCode: "+968",
    companyName: "",
    mobile: "",
    description: "",
  });
  const [callBackDataError, setCallBackDataError] = useState({});
  const [isSubscribed, setIsSubscribed] = useState(true);
  const [loading, setLoading] = useState(false)
  const [serviceRequestType, setServiceRequestType] = useState("");
  const [sourceType, setSourceType] = useState("");

  // const setModal = () => {
  //   setClickHereModal(!clickHereModal);
  // };
  const modalClose = () => {
    setSuccessModal(!successModal);
  }

  const handleAutocompleteChange = (e, newValue) => {
    if (newValue?.phone) {
      setCallBackData((prev) => ({ ...prev, countryCode: newValue.phone }));
      setCallBackDataError((prev) => ({ ...prev, countryCode: "" }));
    }
  };
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setCallBackData((prev) => ({ ...prev, [name]: value }));
    setCallBackDataError((prev) => ({ ...prev, [name]: "" }));
  };

  // const handleCheckboxChange = () => {
  //   setIsSubscribed((prev) => !prev);
  // };

  const leadHandler = (serviceRequestType, sourceType) => {
    setGetHomeInsuranceQuotesModalOpen(true)
    setServiceRequestType(serviceRequestType)
    setSourceType(sourceType)
  }

  const validateForm = () => {
    let errors = {};
    let isValid = true;
    const emailPattern = /^(^$)|([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
    const mobilePattern = /^[0-9]{7,12}$/;
    const namePattern = /^[A-Za-z ]{3,}$/;

    if (!callBackData.name.match(namePattern)) {
      errors.name = "Invalid Full Name (min 3 letters)";
      isValid = false;
    }
    if (!callBackData.email.match(emailPattern)) {
      errors.email = "Invalid email format";
      isValid = false;
    }
    if (!callBackData.mobile.match(mobilePattern)) {
      errors.mobile = "Invalid mobile number";
      isValid = false;
    }
    if (!callBackData.countryCode) {
      errors.countryCode = "Please Select Country Code";
      isValid = false;
    }
    // if (!callBackData.companyName) {
    //   errors.companyName = "Please Enter Company Name";
    //   isValid = false;
    // }
    // if (!callBackData.description || callBackData.description.length < 20 || callBackData.description.length > 350) {
    //   errors.description = "Description should be between 20 and 350 characters.";
    //   isValid = false;
    // }
    setCallBackDataError(errors);
    return { isValid, errors };
  };


  const proceedHandler = async () => {
    let validationData = validateForm(callBackData);
    if (!validationData.isValid) return;

    setLoading(true);
    const data = {
      policyId: "",
      channel: "",
      productId: "generalProduct123",
      serviceType: "GeneralLeadRequest",
      created_by_userId: "",
      created_by: "user",
      data: {
        name: callBackData.name,
        email: callBackData.email,
        policyNo: "",
        typeOfFeedBack: "",
        summary: "",
        description: callBackData.description,
        documents_list: [],
        receivePromotions: isSubscribed,
        sourceType: sourceType,
        leadType: serviceRequestType,
        ...(callBackData.mobile?.trim() && {
          mobile: callBackData.countryCode + callBackData.mobile.trim(),
        }),
      }
    };

    try {
      const resultData = await createServiceRequestOfFeedback(data);
      if (resultData?.data?.code === 0) {
        let uniqueId = resultData?.data?.payload?.service_id;
        // Send Mail After Success
        await sendLeadNotificationEmail(data.data, sourceType, uniqueId);
        setLoading(false);
        setSuccessModal(true);
        setGetHomeInsuranceQuotesModalOpen(false);
      }
    } catch (error) {
      console.error("API Error:", error);
      setLoading(false);
    }
  };

  return (
    <div className="HomeBanner">
      <div className="bottomLeft">
        <div className="bannerLftImg">
          <picture>
            <source media="(min-width: 768px)" srcSet={`${CDN_URL}landing_bottom_lft_img.webp`} />
            <img
              src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'/%3E"
              alt="Left Side Home Image"
              title="Left Side Home Image"
              width="631"
              height="355"
              loading="lazy"
              decoding="async"
            />
          </picture>
        </div>
      </div>
      <div className="bottomRight">
        <div className="bannerRgtImg">
          <picture>
            <source media="(min-width: 768px)" srcSet={`${CDN_URL}landing_bottom_rgt_Img.webp`} />
            <img
              src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'/%3E"
              alt="Right Side Home Image"
              title="Right Side Home Image"
              width="631"
              height="355"
              loading="lazy"
              decoding="async"
            />
          </picture>
        </div>
      </div>
      <div className="container">
        <div className="InsuranceNeeds">
          {lang === "ar" ?
            <h1 className="arHdTxt">
              انقر - قارن - <span className="SaveTxt">وفر</span><br />

              <span className="insTxt">التأمين ببساطة</span>

            </h1>
            :
            <h1 className="engHdTxt">Click -  Compare - <span className="SaveTxt">Save</span> <br />
              <span className="insTxt">Insurance made simple</span>
            </h1>}
          {/* <div className="headingCarouselFlx">
            <div className="headingItemLft">
              {lang === "ar" ? <h1 className="arHdTxt">شريك العصر الجديد لجميع<br />احتياجاتك التأمينية</h1> : <h1 className="engHdTxt">New-age partner for all your{" "}
                <span>Insurance</span> needs
              </h1> }
              
            </div>
            <div className="headItemRgt">
              <BannerCarousel />
            </div>
          </div> */}
          <div className="PlanBoxes">
            <div className="motorBox shine" onClick={() => {
              setLangInSession()
              navigate((lang === "ar" ? "/ar" : "") + "/motor-insurance/carsecure/motor-basic-form")
            }}>
              <div className="BoxContent">
                <div className="motorArrow">
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </div>
                {lang === "ar" ? <div className="boxTitle">تأمين<br />السيارات</div> :
                  <div className="boxTitle">Motor Insurance</div>
                }
                <img src={`${CDN_URL}moto_insu_card_img.webp`} alt="Motor Insurance" title="Motor Insurance" width="293" height="119" loading="eager" fetchPriority="high" decoding="async" />
              </div>
            </div>
            <div
              className="travelBox shine" onClick={() => {
                setLangInSession()
                navigate((lang === "ar" ? "/ar" : "") + "/travel-insurance/tripsecure/travel-basic-form")
              }
              }>
              <div className="travelContent">
                <div className="travelArrow">
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </div>
                {lang === "ar" ?
                  <div className="travelTitle">تأمين على<br />السفر</div> :
                  <div className="travelTitle">Travel Insurance</div>
                }
                <img src={`${CDN_URL}travel_card_img.webp`} alt="Travel Insurance" title="Travel Insurance" width="293" height="119" loading="lazy" />
              </div>
            </div>

            <div className="houseBox shine"
              onClick={() => {
                setLangInSession()
                navigate((lang === "ar" ? "/ar" : "") + "/domestic-insurance/domesticsecure/domestic-basic-form")
              }}>
              <div className="houseContent">
                <div className="houseMaidArrow">
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </div>
                {lang === "ar" ?
                  <div className="houseTitle">تأمين عاملات<br />المنازل</div> :
                  <div className="houseTitle">Domestic Helper Insurance</div>
                }
                <img src={`${CDN_URL}house_maid_card_img.webp`} alt="House Maid Insurance" title="Domestic Helper Insurance" width="293" height="119" loading="lazy" />
              </div>
            </div>

            <div className="homeBox shine" onClick={() => { const title = lang === "ar" ? "تأمين على المنازل" : "Home Insurance"; leadHandler("HomeGeneralRequest", title); }}>
              <div className="homeContent">
                <div className="homeArrow">
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </div>
                {lang === "ar" ?
                  <div className="travelTitle">تأمين على<br />المنازل</div> :
                  <div className="homeTitle">Home Insurance</div>
                }
                <img src={`${CDN_URL}home_insu_card_img.webp`} alt="Home Insurance" title="Home Insurance" width="293" height="119" loading="lazy" />
              </div>
            </div>
            {/* <div className="houseBox shine" onClick={() => { const title = lang === "ar" ? "تأمين عاملات المنازل" : "House Maid Insurance"; leadHandler("HouseMaidGeneralRequest", title); }}>
              <div className="houseContent">
                {lang === "ar" ? <div className="houseTitle">تأمين عاملات<br />المنازل</div> : <div className="houseTitle">House Maid Insurance</div>}<img src={`${CDN_URL}house_maid_card_img.webp`} alt="House Maid Insurance" title="House Maid Insurance" />
              </div>
            </div> */}
            <div className="creditBox shine" onClick={() => { const title = lang === "ar" ? "تأمين على القروض" : "Credit Life Insurance"; leadHandler("CreditLifeGeneralRequest", title); }}>
              <div className="creditContent">
                <div className="creditArrow">
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </div>
                {lang === "ar" ?
                  <div className="creditTitle">التأمين على الحياة<br />الائتمانية</div> :
                  <div className="creditTitle">Credit Life Insurance</div>
                }
                <img src={`${CDN_URL}credit_life_card_img.webp`} alt="Credit Life Insurance" title="Credit Life Insurance" width="293" height="119" loading="lazy" />
              </div>
            </div>
            <div className="medicalBox shine" onClick={() => { const title = lang === "ar" ? "التأمين الطبي" : "Medical Insurance"; leadHandler("MedicalGeneralRequest", title); }}>
              <div className="medicalContent">
                <div className="medicalInsArrow">
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </div>
                {lang === "ar" ?
                  <div className="medicalTitle">تأمين طبي</div> :
                  <div className="medicalTitle">Medical Insurance</div>
                }
                <img src={`${CDN_URL}medical_insu_card_img_2.webp`} alt="Medical Insurance" title="Medical Insurance" width="293" height="119" loading="lazy" />
              </div>
            </div>
            <div className="boatBox shine" onClick={() => { const title = lang === "ar" ? "التأمين على القوارب" : "Boat Insurance"; leadHandler("MarineGeneralRequest", title); }}>
              <div className="boatContent">
                <div className="boatArrow">
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </div>
                {lang === "ar" ?
                  <div className="boatTitle">تأمين<br />القوارب</div> :
                  <div className="boatTitle">Boat <br />Insurance</div>
                }
                <img src={`${CDN_URL}boat_insu_card_img.webp`} alt="Boat Insurance" title="Boat Insurance" width="293" height="119" loading="lazy" />
              </div>
            </div>
            <div className="corporateBox shine" onClick={() => { const title = lang === "ar" ? "التأمين التجاري" : "Corporate Insurance"; leadHandler("CorporateGeneralRequest", title); }}>
              <div className="corporateContent">
                <div className="corporateArrow">
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </div>
                {lang === "ar" ?
                  <div className="corporateTitle">التأمين<br />التجاري</div> :
                  <div className="corporateTitle">Corporate Insurance</div>
                }
                <img src={`${CDN_URL}commercial_Insu_img.webp`} alt="Commercial Insurance" title="Commercial Insurance" width="293" height="119" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* AUTHORIZED GROUP SECTION FOUR STARTS HERE */}
      <div className="authorizedGroup">
        <div className="authorizedContent">
          <div className="authorItemLft">
            <div className="oneicLogo">
              <img src={`${CDN_URL}oneic_logo_114px_114px.webp`} width={55} height={55} className="oneicLogo"
                alt="ONEIC logo" title="ONEIC Logo" loading="lazy" />
            </div>
            <div className="oneicLogoTxt">
              <span className="pwrBytxt">Power by</span>
              <span className="compnyNm">
                {t("HM_ONIC_GROUP_COMPANY")}
              </span>
            </div>
          </div>
          <div className="authorItemRgt">

            <img src={`${CDN_URL}fsa_logo_430px_108px.webp`}
              width={160}
              height={40}
              className="fsaLogo"
              alt="FSA logo"
              title="FSA Logo"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
      {/* AUTHORIZED GROUP SECTION FOUR ENDS HERE */}
      {/* HOME INSURANCE MODAL STARTS HERE */}
      <Modal isOpen={isGetQuotesHomeInsuranceModalOpen} closeModal={closeGetQuotesModal} widthClass="modal-width-40">
        <div className={lang === "ar" ? "homeReqModalTitle dirRtl" : "homeReqModalTitle"}>
          {/* {lang === "ar" ? "أفضل عروض التأمين، دائماً!" : "Best Insurance Offers, Always!"} */}
          {sourceType}
        </div>
        <div className={lang === "ar" ? "homeReqSubTxt dirRtl" : "homeReqSubTxt"}>
          {lang === "ar" ? "يرجى تعبئة بياناتك، وسيتواصل معك موظفينا في أقرب وقت." : "Please fill in your details, and our expert insurance advisor will contact you shortly."}
        </div>
        {/* <div className="sourceTypeHdTxt">
          
        </div> */}
        <div className="homeReqFromFx">

          <div className="homeReqFieldItemHalf">
            <CustomInput label={lang === "ar" ? "* الاسم الكامل" : "Name *"}
              name="name"
              value={callBackData.name}
              onChange={onChangeHandler}
            />
            {callBackDataError.name && <Error msg={callBackDataError.name} />}
          </div>
          <div className="homeReqFieldMobItem">
            <div className="cntCodeItem">
              <AutoComplete name="countryCode" placeholder={t("PLACEHOLDER_RTO_CODE")} value={{ phone: callBackData.countryCode }} onChange={handleAutocompleteChange} />
              {callBackDataError.countryCode && <Error msg={callBackDataError.countryCode} />}
            </div>
            <div className="mobileNumItem">
              <CustomInput
                label={lang === "ar" ? "* رقم الهاتف " : "Mobile Number *"}
                type="tel"
                name="mobile"
                maxLength={10}
                value={callBackData.mobile}
                onChange={onChangeHandler}
              />
              {callBackDataError.mobile && <Error msg={callBackDataError.mobile} />}
            </div>
          </div>

          <div className="homeReqFieldItem">
            <CustomInput
              label={lang === "ar" ? "عنوان البريد الإلكتروني" : "Email"}
              type="email"
              name="email"
              value={callBackData.email}
              onChange={onChangeHandler}
            />
            {callBackDataError.email && <Error msg={callBackDataError.email} />}
          </div>
          {/* <div className="callBkFieldItem">
            <CustomInput 
              label={t("CompanyName")}
              name="companyName"
              value={callBackData.companyName}
              onChange={onChangeHandler}
            />
            {callBackDataError.companyName && <Error msg={callBackDataError.companyName} />}
          </div> */}
          <div className="homeReqFieldItem">
            <Textarea
              label={lang === "ar" ? "اختصار" : "Brief Details"}
              name="description"
              value={callBackData.description}
              onChange={onChangeHandler}
            />
            {callBackDataError.description && <Error msg={callBackDataError.description} />}
          </div>
          <div className="homeReqItemFx">
            {lang === "ar" ?
              <div className="itemFx dirRtl"><i className="fa-solid fa-star"></i> المزيد من التوفير
              </div>
              :
              <div className="itemFx"><i className="fa-solid fa-star"></i> Fast Response</div>
            }
            {lang === "ar" ?
              <div className="itemFx dirRtl"><i className="fa-solid fa-star"></i> مقارنة العروض</div>
              :
              <div className="itemFx"><i className="fa-solid fa-star"></i> Compare Offers</div>
            }
            {lang === "ar" ?
              <div className="itemFx dirRtl"><i className="fa-solid fa-star"></i> استجابة سريعة</div>
              :
              <div className="itemFx"><i className="fa-solid fa-star"></i> More Savings</div>
            }
          </div>
          <div className="homeReqChkItem">
            <div className="chkItem">
              <CustomCheckbox colorClass="blue"
                checked={isSubscribed}
                onChange={handleCheckboxChange}
              />
            </div>
            {lang === "ar" ?
              <div className="homeReqChkItemTxtAr dirRtl">
                بالنقر على "المتابعة"، أؤكد أنني قرأت ووافقت على سياسة الخصوصية والشروط والأحكام
              </div>
              :
              <div className="homeReqChkItemTxt">By clicking "Proceed," I confirm that I have read and agree to the <a href="/privacy-policy" target="_blank">Privacy Policy</a> and <a href="/terms-and-conditions" target="_blank">Terms & Conditions.</a></div>
            }
          </div>
          <div className=""></div>
          <div className="homeReqBtn">
            {loading ?
              <ButtonLoader bgColor="#d95e76" textColor="#fff" />
              :
              <Button label={lang === "ar" ? "متابعه" : "PROCEED"}
                status={true}
                isIcon={false}
                clickFunction={proceedHandler}
                buttonType="proceed-btn"
              />
            }
          </div>
        </div>
      </Modal>
      {/* HOME INSURANCE MODAL ENDS HERE */}

      {/* HOME INSURANCE SUCCESS MODAL STARTS HERE */}
      <Modal isOpen={successModal} closeModal={modalClose} widthClass="modal-width-45">
        <div className="reqCalBkThankFlx">
          <div className="reqTnkInc">
            <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" fill="none" viewBox="0 0 120 120">
              <path fill="#000" d="M73.448 17.711s-5.612-1.403-16.326-1.148c-10.715.255-44.516.638-46.557 8.419-2.04 7.78 3.7 80.713 4.465 84.95.765 4.236 4.209 4.236 17.73 4.236 13.52 0 49.49-5.64 52.55-7.425 3.062-1.786 4.21-6.378 4.21-6.378L73.448 17.711Z" />
              <path fill="#599EFC" d="M80.082 24.088c-1.02-2.423 1.125-7.71-13.138-6.888-13.266.766-45.34 3.166-50 8.546-3.856 4.452.51 78.035 4.719 82.272 4.209 4.236 64.316-3.149 67.475-6.506 3.764-3.999-9.056-77.424-9.056-77.424Z" />
              <path fill="#80D092" d="M82.632 26.512s-2.806-6.888-4.21-7.398c-1.402-.51-56.632 6.377-58.418 9.311-1.786 2.934 7.015 70.154 8.163 73.853 1.148 3.699 34.834-1.096 53.52-6.103 7.195-1.928.945-69.663.945-69.663Z" />
              <path fill="#FDE580" d="M21.645 27.143s51.41-10.102 57.543-9.38c6.133.721 13.272 42.851 21.466 53.574 7.306 9.56 6.213 11.486-12.086 18.94-24.352 9.922-42.751 9.922-48.884 8.479C33.55 97.313 20.382 39.589 19.3 34.178c-1.082-5.412 0-6.494 2.345-7.035Z" />
              <path fill="#FD6B6A" d="M24.004 18.86s9.524.89 11.037 2.759c1.514 1.869-1.157 10.058 3.205 10.948 4.361.89 25.368-2.225 27.771-4.985 2.404-2.759 3.205-12.728-4.984-13.351-8.19-.623-5.697-2.582-9.168-6.142-3.472-3.56-8.902-2.848-9.792 1.958-.89 4.807-6.23 5.34-11.571 5.074-5.34-.267-6.498 3.738-6.498 3.738Z" />
              <path fill="#fff" d="M47.279 9.024c-2.27.534-4.273 5.518.623 4.984 4.895-.534 3.382-6.053-.623-4.984Z" />
              <path fill="#000" d="M37.566 21.469c16.24-2.077 29.079-3.21 27.631-3.588-1.447-.377-4.028-2.014-7.93-2.454-3.903-.441-12.274 2.769-19.575 1.95-7.3-.817-10.322 0-8.497.567 1.825.567 7.301 1.888 8.371 3.525Z" />
              <path fill="#fff" d="M30.369 41.112s46.146-7.166 48.439-9.03c2.293-1.862-10.892.43-18.774 2.007-7.882 1.577-24.936 3.726-28.519 4.873-3.583 1.146-3.726 2.436-1.146 2.15Zm2.027 8.714s46.146-7.165 48.44-9.028c2.292-1.863-10.892.43-18.775 2.006-7.882 1.577-24.936 3.726-28.519 4.873-3.582 1.146-3.726 2.436-1.146 2.15Z" />
              <path fill="#80D092" d="M43.247 59.218s38.138-6.512 40.43-8.375c2.293-1.863-10.891.43-18.773 2.006-7.882 1.577-16.927 3.072-20.51 4.219-3.583 1.146-3.726 2.436-1.147 2.15Zm2.028 8.714s38.137-6.511 40.43-8.374c2.293-1.864-10.892.43-18.774 2.006-7.882 1.576-16.927 3.072-20.51 4.219-3.582 1.146-3.726 2.436-1.146 2.15Zm4.285 9.866s38.137-6.512 40.43-8.375c2.293-1.863-10.892.43-18.774 2.006-7.882 1.577-16.927 3.072-20.51 4.219-3.582 1.146-3.726 2.436-1.146 2.15Zm2.027 8.715S89.724 80 92.017 78.138c2.293-1.863-10.891.43-18.773 2.006-7.883 1.576-16.927 3.072-20.51 4.219-3.583 1.146-3.726 2.436-1.147 2.15Z" />
              <path fill="#fff" d="M93.237 69.588c-2.753 4.81-14.668 9.652-16.132 8.807-1.463-.845-2.755-14.924-.017-19.742 6.725-11.648 19.395 1.602 16.15 10.935Z" />
              <path fill="#599EFC" d="m88.504 38.645-10.89 18.863a7.69 7.69 0 0 0-.524 1.144c.87-.587 1.77-.595 2.554.618 2.534 3.923.9 7.928 5.313 5.23 4.413-2.697 3.35 1.063 4.495 3.433.64 1.328 1.616 2.296 3.787 1.655.73-.715 1.321-1.415 1.702-2.075l10.641-18.43c.999-14.523-7.117-16.737-17.078-10.438Z" />
              <path fill="#000" d="M95.635 38.264c-.4-.006-.834.051-1.28.166-2.861.736-14.14 21.658-14.14 21.658l-.059.086c1.802 3.595.726 6.816 4.8 4.327.927-.567 1.61-.846 2.125-.915 2.08-4.377 6.725-14.47 9.235-18.782 2.689-4.62 1.48-6.505-.681-6.54Zm9.827 5.288-16.2 23.934c.055.153.116.303.186.447.64 1.328 1.616 2.296 3.787 1.655.73-.715 1.322-1.415 1.703-2.075l10.64-18.43c.144-2.097.098-3.936-.116-5.531Z" />
              <path fill="#FD6B6A" d="M95.93 30.34c-1.65.008-3.099.81-4.311 2.91l-3.115 5.396c3.13.838 9.363 3.005 14.35 7.875.99.966 1.892 1.809 2.727 2.562l3.365-5.828c2.771-4.8-.946-7.285-5.746-10.056-2.699-1.56-5.15-2.867-7.27-2.858Z" />
              <path fill="#000" d="M75.691 72.616c.288 3.06.836 5.445 1.412 5.778.61.352 3.04-.286 5.863-1.497-1.175-2.765-4.585-3.866-7.275-4.28Zm22.883-40.66c-2.646-1.616-3.063-.058.635 1.965 3.699 2.023 7.397 4.681 8.38 3.988.982-.694-9.015-5.953-9.015-5.953Z" />
              <path fill="#fff" d="M105.577 49.082s-6.731-5.586-10.654-7.343C91 39.982 88.5 38.645 88.5 38.645s.62-.91 5.156.847c4.536 1.757 9.44 5.19 10.911 6.783 1.471 1.594 1.01 2.807 1.01 2.807Z" />
              <path fill="#80D092" d="M38.53 59.291a2.311 2.311 0 1 1-4.623 0 2.311 2.311 0 0 1 4.622 0Z" />
              <path fill="#fff" d="M40.9 68.769a2.312 2.312 0 1 1-4.623 0 2.312 2.312 0 0 1 4.623 0Z" />
              <path fill="#80D092" d="M43.498 78.304a2.311 2.311 0 1 1-4.622 0 2.311 2.311 0 0 1 4.622 0Z" />
              <path fill="#fff" d="M46.158 86.684a2.312 2.312 0 1 1-4.623 0 2.312 2.312 0 0 1 4.623 0Z" />
            </svg>
          </div>
          {lang === "ar" ?
            <div className="reqTnkHdTxt dirRtl">شكرًا لك</div>
            :
            <div className="reqTnkHdTxt">Thank you!</div>
          }
          {lang === "ar" ?
            <div className="reqTnkSubTxt dirRtl">تم إرسال النموذج بنجاح {sourceType}</div>

            :
            <div className="reqTnkSubTxt">{sourceType} request received successfully</div>
          }
          {lang === "ar" ?
            <div className="reqTnkDecTxt dirRtl">
              سيتم التواصل معك قريباً من قبل احد موظفينا لفهم متطلباتك.
            </div>
            :
            <div className="reqTnkDecTxt">One of our insurance advisors will get in touch with you shortly to understand the requirements</div>
          }
          <div className="returnHmBtnSec">
            <Button
              label={lang === "ar" ? "متابعه" : "RETURN TO HOME"}
              status={true}
              isIcon={false}
              clickFunction={() => {
                setSuccessModal(false);
                window.scroll(0, 0)
                window.location.reload(); // Reloads the page
              }}
              buttonType="proceed-btn"
            />
          </div>
        </div>
      </Modal>
      {/* HOME INSURANCE SUCCESS MODAL ENDS HERE */}
    </div>
  );
};

export default HomePageBanner;
